export const SUMMARY_FIELDS = [
    {
        key: "AP_Code",
        label: "รหัสเจ้าหนี้",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "AP_Name",
        label: "ชื่อเจ้าหนี้",
        w: "20%",
        alignHeader: "center",
        align: "left",
        numeric: false,
        sortable: true,
    },
    {
        key: "NetTotal",
        label: "ยอดสุทธิ",
        w: "7%",
        alignHeader: "end",
        align: "end",
        numeric: true,
        sortable: true,
    },
];

export const DETAIL_FIELDS = [
    {
        key: "Doc_Date",
        label: "วันที่",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Doc_No",
        label: "เลขที่เอกสาร",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "DocType_Name",
        label: "ประเภท",
        w: "17%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "DocStatus_Name",
        label: "สถานะเอกสาร",
        w: "50%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "NetTotal",
        label: "ราคารวม",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
];
